import { useMemo } from 'react';
import { useClientSelectListQuery } from 'api';

export const useClientMapping = (): Record<string, any> => {
  const { data: clientList = [] } = useClientSelectListQuery();
  const clientMapping: Record<string, { name: string; id: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; id: string }> = {};
    clientList.forEach((i: { name: string; id: string }) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [clientList]);

  return {
    clientMapping,
  };
};
